import { styled as e } from "./styled2.mjs";
import r from "./CircularProgress.mjs";
import o from "./circularProgressClasses.mjs";
const l = e("div")`
	position: fixed;
	z-index: ${({ theme: t }) => t.zIndex.loader};
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: ${({ theme: t }) => t.palette.background.paper};
`, c = e("div")`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: ${({ $height: t, $fullHeight: i }) => i ? "100%" : `${t || 342}px`}; /* registration lists height */
`, p = e("div")`
	display: inline-flex;
	position: relative;
	align-items: center;
	justify-content: center;
	height: max-content;
`, d = e(r)`
	position: absolute;
	left: 0;
	animation-duration: 1s;
	color: ${({ theme: t }) => t.palette.primary.main};

	& .${o.circle} {
		stroke-dashoffset: 50px;
	}
`, m = e(r)`
	color: ${({ theme: t }) => t.palette.primary.main};
	opacity: 0.5;

	& .${o.circle} {
		stroke-linecap: round;
	}
`;
export {
  l as GlobalWrapper,
  p as LoaderWrapper,
  d as StyledLoader,
  m as StyledLoaderBackground,
  c as Wrapper
};
//# sourceMappingURL=styles21.mjs.map
